import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ProfileUpdateFilterNamePipe } from '@app/pipes/profile-update-filter-name.pipe';

@Component({
  selector: 'filter-tag-select',
  templateUrl: './filter-tag-select.component.html',
  styleUrls: ['./filter-tag-select.component.css']
})
export class FilterTagSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() title: string = '';
  @Input() defaultValue: string = '';
  @Input() pipe: 'profileUpdateFilter' | null = null;

  @Output() eventResetControl = new EventEmitter<undefined>();

  public pipeName: any = null;

  constructor() { }

  ngOnInit() {
    // use only the necessary pipes
    switch (this.pipe) {

      case 'profileUpdateFilter':
        this.pipeName = ProfileUpdateFilterNamePipe;
        break;
    }
  }


  onClickResetControl(event: MouseEvent): void {
    event.preventDefault();
    this.control.setValue(this.defaultValue);
    this.eventResetControl.next(undefined);
  }
}